import api from '../api';

export const getSources = (token, feature) =>
  api({
    method: 'get',
    url: `sources/${token}`,
    params: { feature }
  });
